import { render, staticRenderFns } from "./itemData.vue?vue&type=template&id=361f6d93&class=full-heigth&"
import script from "./itemData.vue?vue&type=script&lang=js&"
export * from "./itemData.vue?vue&type=script&lang=js&"
import style0 from "./itemData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('361f6d93')) {
      api.createRecord('361f6d93', component.options)
    } else {
      api.reload('361f6d93', component.options)
    }
    module.hot.accept("./itemData.vue?vue&type=template&id=361f6d93&class=full-heigth&", function () {
      api.rerender('361f6d93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/itemData.vue"
export default component.exports